<template>
  <div>
    <h5
      style="
        display: flex;
        justify-content: center;
        font-weight: 400;
        padding-top: 10px;
        padding-bottom: 30px;
      "
    >
      Update Distribution Centre
    </h5>
    <a-form-model
      ref="centreForm"
      :model="distroCentre"
      :rules="rules"
      :wrapper-col="wrapperCol"
      @submit.prevent="handleUpdate"
      style="margin: mx-auto"
    >
      <a-row>
        <a-col :span="22" :offset="1">
          <a-form-model-item label="Centre's Name:" ref="name" prop="name">
            <a-input
              placeholder="Distribution Centre Name"
              v-model="distroCentre.name"
              @blur="
                () => {
                  $refs.name.onFieldBlur();
                }"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="22" :offset="1">
          <a-form-model-item label="Centre's Address:" ref="address" prop="address">
            <a-input
              placeholder="Distribution Centre Address"
              v-model="distroCentre.address"
              @blur="
                () => {
                  $refs.address.onFieldBlur();
                }"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="22" :offset="1">
          <a-form-model-item label="Centre's Type:" ref="type" prop="type">
            <a-select @blur="
                () => {
                  $refs.type.onFieldBlur();
                }" 
                v-model="distroCentre.type" 
                placeholder="please select your option">
                <a-select-option value="0">
                    Physical
                </a-select-option> 
                <a-select-option value="1">
                    Virtual
                </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
   
      <a-form-model-item
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          padding-top: 10px;
        "
      >
        <a-row>
            <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                    <a-spin class="spinner" :spinning="loading" />
            </div>
          <a-col :span="22" :offset="6">
            <a-button
              @click="handleUpdate"
              style="
                background: #418a49;
                height: 50px;
                color: #fff;
                width: 263px;
                border-radius: 5px;
              "
            >
              Update Centre
            </a-button>
          </a-col>
        </a-row>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
export default {
  name: "UpdateDistroCentre",
  props: { distroCentre: {type: Object, default: function() {return {}}}},
  data: () => ({
    loading: false,
    labelCol: { span: 6 },
    wrapperCol: { span: 24 },
    rules: {
      name: {
        required: true,
        message: "Centre's name is required",
        trigger: "blur",
      },
      address: {
        required: true,
        message: "Centre's address is required",
        trigger: "blur",
      },
      type: {
        required: true,
        message: "Centre's type is required",
        trigger: "blur",
      },
    },
  }),
  methods: {
    handleUpdate() {
      this.$refs.centreForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          const payload = {
            id: this.distroCentre.id,
            data: {
            name: this.distroCentre.name,
            address: this.distroCentre.address,
            type: this.distroCentre.type
            }
          }
          const res = await this.$store.dispatch("distroCenter/UpdateDistroCenter", payload);
          if(res.code === 201) {
            console.log(res)
            this.loading = false
            this.$notification[res.status]({
                message: 'Successfully updated distribution centre.'
            });
            setTimeout(function() {location.reload();}, 2000)
          }else {
            this.$notification[res.status]({
                message: 'Error updating centre'
            });
          }
        } else {
          this.$notification['error']({
                message: 'please fill all required fields'
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-form-item-label {
  display: block;
}
</style>